import { useEffect, useState } from 'react'

// Returns the id of the section crossing the middle of the viewport.
export const useActiveSection = (ids: string[]): string | null => {
    const [active, setActive] = useState<string | null>(null)
    const key = ids.join(',')

    useEffect(() => {
        const elements = key
            .split(',')
            .filter(Boolean)
            .map(id => document.getElementById(id))
            .filter((element): element is HTMLElement => element !== null)

        if (elements.length === 0) return

        const observer = new IntersectionObserver(entries => {
            for (const entry of entries) {
                if (entry.isIntersecting) setActive(entry.target.id)
            }
        }, { rootMargin: '-45% 0px -50% 0px' })

        elements.forEach(element => observer.observe(element))

        return () => observer.disconnect()
    }, [key])

    return active
}
